import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function MagicLink() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const nav = useNavigate();
  const { setUser } = useAuth();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    if (!token) { nav("/login"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/magic-link/verify", { token });
        localStorage.setItem("hc_token", data.token);
        setUser(data.user);
        nav("/dashboard");
      } catch (err) {
        nav(`/login?magic_error=${encodeURIComponent(err.response?.data?.detail || "expired")}`);
      }
    })();
  }, [token, nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FCFAF8]">
      <p className="text-[#7A736E]" data-testid="magic-link-loading">Signing you in…</p>
    </div>
  );
}
